module.exports = __webpack_public_path__ + "static/img/rlsp.eaa3448a.png";